export const availableFacilities = [
  'WiFi',
  'AC',
  'TV',
  'Mini Bar',
  'Jacuzzi',
  'Balcony',
  'Kitchenette',
  'Spa Access',
  'Pool Access',
  'Gym Access',
  'Breakfast',
  'Parking',
  'Room Service',
  'Laundry Service',
  'Airport Transfer',
  'Meeting Room',
  'Business Center',
];
